import { render, staticRenderFns } from "./iitem.vue?vue&type=template&id=1875da30"
import script from "./iitem.vue?vue&type=script&lang=js"
export * from "./iitem.vue?vue&type=script&lang=js"
import style0 from "./iitem.vue?vue&type=style&index=0&id=1875da30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports